module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.guestList', {
            url: '/suggestedlists?{pageNumber:int}&{sortBy}',
            resolve: {
                modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load('lists');
                }],
            },
            onEnter: ['$state', '$stateParams', 'ShopperService', 'SuggestedListService', ($state, $stateParams, shopperService, suggestedListService) => {
                if (!shopperService.IsGuest) {
                    $state.go('shop.list');
                    return;
                }
                if ($stateParams.listId) {
                    return;
                }
                // Navigate to first suggested list by default
                suggestedListService.listSuggestedLists().then(() => {
                    const firstSuggestedList = suggestedListService.suggestedLists[0];
                    // Do not keep history (replace) to prevent the user from going back to an empty page
                    $state.go('shop.suggestedlists', { listId: firstSuggestedList.ID }, { location: 'replace' });
                });
            }],
            views: {
                'left-panel@shop': {
                    template: '<wow-list-sidebar></wow-list-sidebar>',
                },
            },
            data: {
                pageMetadata: {
                    title: 'Lists - Woolworths Online',
                    metaDescription: 'Lists - Woolworths Online',
                    metaRobot: 'noindex',
                },
            },
        })
        .state('shop.suggestedlists', {
            url: '/suggestedlists/{listId:int}?{pageNumber:int}&{sortBy}',
            resolve: {
                modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load('lists');
                }],
            },
            views: {
                'left-panel@shop': {
                    template: '<wow-list-sidebar></wow-list-sidebar>',
                },
                'center-panel@shop': {
                    controller: ['$stateParams', function ($stateParams) {
                        this.listId = $stateParams.listId;
                        this.pageNumber = $stateParams.pageNumber || 1;
                        this.sortBy = $stateParams.sortBy;
                    }],
                    controllerAs: '$ctrl',
                    template: '<wow-suggested-list-tile-list list-id="$ctrl.listId" page-number="$ctrl.pageNumber" sort-by="$ctrl.sortBy"></wow-suggested-list-tile-list>',
                },
                'rr-instrumentation-panel@root': {
                    controller: ['ShopperService', function (shopperService) {
                        this.isGuest = shopperService.IsGuest;
                    }],
                    controllerAs: '$ctrl',
                    template: '<wow-rr-generic-instrumentation ng-if="!$ctrl.isGuest"></wow-rr-generic-instrumentation>',
                },
            },
        })
        .state('shop.list', {
            url: '/mylists?{pageNumber:int}&{sortBy}&{filter:filter}&{filterOpen:bool}&{openFilter:string}',
            reloadOnSearch: false,
            resolve: {
                modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load('lists');
                }],
            },
            views: {
                'center-panel@shop': {
                    controller: ['$state', function ($state) {
                        this.$state = $state;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-saved-lists-default-list
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy"
                            filter="$ctrl.$state.params.filter">
                        </wow-saved-lists-default-list>
                    `,
                },
                'left-panel@shop': {
                    template: '<wow-list-sidebar></wow-list-sidebar>',
                },
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-wishlist-instrumentation></wow-rr-wishlist-instrumentation>',
                },
            },
            data: {
                authenticate: true,
                pageMetadata: {
                    title: 'Lists - Woolworths Online',
                    metaDescription: 'Lists - Woolworths Online',
                    metaRobot: 'noindex',
                },
            },
        })
        .state('shop.list.reorder', {
            url: '/reorder',
            views: {
                'center-panel@shop': {
                    template: `
                        <wow-reorder-list></wow-reorder-list>
                    `,
                },
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-generic-instrumentation page-group="reorder" placement-ids="generic_page.quick_reorder"></wow-rr-generic-instrumentation>',
                },
            },
        })
        .state('shop.list.pastshops', {
            url: '/pastshops/{orderId}',
            reloadOnSearch: false,
            views: {
                'center-panel@shop': {
                    controller: ['$state', function ($state) {
                        this.$state = $state;
                        this.orderId = $state.params.orderId === 'everything' ? $state.params.orderId : parseInt($state.params.orderId);
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-tile-list-with-content>
                            <wow-past-shop-tile-list order-id="$ctrl.orderId"
                                page-number="$ctrl.$state.params.pageNumber || 1"
                                sort-by="$ctrl.$state.params.sortBy"
                                filter="$ctrl.$state.params.filter">
                            </wow-past-shop-tile-list>
                        </wow-tile-list-with-content>
                    `,
                },
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-mypage-instrumentation></wow-rr-mypage-instrumentation>',
                },
            },
        })
        .state('shop.list.edit', {
            url: '/{listId}',
            reloadOnSearch: false,
            resolve: {
                // Needed for Rewards check
                modules: ['$ocLazyLoad', function ($ocLazyLoad) {
                    return $ocLazyLoad.load('myaccount');
                }],
            },
            views: {
                'left-panel@shop': {
                    controller: ['$stateParams', function ($stateParams) {
                        this.listId = parseInt($stateParams.listId);
                        this.isRewardsList = $stateParams.listId === 'MyWoolworthsRewards';
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-list-edit
                            list-id="$ctrl.listId"
                            is-rewards-list="$ctrl.isRewardsList">
                        </wow-list-edit>
                    `,
                },
                'center-panel@shop': {
                    controller: ['$state', 'ShopperService', 'RewardsLoginService', function ($state, shopperService, rewardsLoginService) {
                        this.$state = $state;
                        this.isRewardsList = $state.params.listId === 'MyWoolworthsRewards';

                        // Redirect to Woolworths Rewards in My Account if they don't have one linked yet
                        if (this.isRewardsList && !shopperService.shopper.RewardsCardNumber) {
                            // Shopperservice is not reliable and may not catch some cases, so we need to do a fetch
                            rewardsLoginService.getRewardsCard().then((response) => {
                                // No response = no card
                                if (!response) {
                                    $state.go('shop.myaccount.woolworthsrewards', null, { location: 'replace' });
                                }
                            });
                        }
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-tile-list-with-content>
                            <wow-saved-list-tile-list
                                page-number="$ctrl.$state.params.pageNumber || 1"
                                sort-by="$ctrl.$state.params.sortBy"
                                list-id="$ctrl.$state.params.listId"
                                is-rewards-list="$ctrl.isRewardsList"
                                filter="$ctrl.$state.params.filter">
                            </wow-saved-list-tile-list>
                        </wow-tile-list-with-content>
                    `,
                },
            },
        })
        .state('shop.list.edit.freetext', {
            url: '/products?searchTerm',
            views: {
                'center-panel@shop': {
                    controller: ['$stateParams', function ($stateParams) {
                        this.searchTerm = $stateParams.searchTerm;
                        this.pageNumber = $stateParams.pageNumber || 1;
                        this.sortBy = $stateParams.sortBy;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-tile-list-with-content>
                            <wow-search-product-tile-list
                                search-term="$ctrl.searchTerm"
                                is-special="false"
                                is-list="true"
                                page-number="$ctrl.pageNumber"
                                sort-by="$ctrl.sortBy">
                            </wow-search-product-tile-list>
                        </wow-tile-list-with-content>
                    `,
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/lists.js